"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GreenhouseLogoTwo = function GreenhouseLogoTwo(_ref) {
  var height = _ref.height,
    color = _ref.color,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: height,
    viewBox: "0 0 29.5086 61.8312",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: "0",
    y: "0",
    width: "29.5086",
    height: "61.8312",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 29.509 0 29.509 61.831 0 61.831 0 0",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("title", null, "g-mark4"), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2419,18.2561a6.5791,6.5791,0,0,0-6.4876-6.6018,6.6034,6.6034,0,0,0,0,13.2048,6.58,6.58,0,0,0,6.4876-6.603m3.387,28.9362c0-5.685-4.1907-10.2776-9.8746-10.2776S4.88,41.5073,4.88,47.1923a9.9662,9.9662,0,0,0,9.8747,10.276,9.9658,9.9658,0,0,0,9.8746-10.276m1.1482-28.8208a10.78,10.78,0,0,1-3.33,7.6932c-2.2963,2.2963-5.6265,2.87-5.6265,4.8222,0,2.6407,4.2482,1.837,8.3253,5.9135A14.6157,14.6157,0,0,1,14.7543,61.8312,14.6153,14.6153,0,0,1,4.363,36.8c4.0765-4.0765,8.3252-3.2728,8.3252-5.9135,0-1.9518-3.33-2.5259-5.6265-4.8222a10.8012,10.8012,0,0,1,7.52-18.6017c1.1481,0,2.182.1728,3.0431.1728,1.5506,0,2.3538-.6895,2.3538-1.7808,0-.6309-.2871-1.4352-.2871-2.2963a3.6462,3.6462,0,0,1,7.2913.1159,3.8458,3.8458,0,0,1-2.9277,3.5587c-1.0334.3439-1.8377.8037-1.8377,1.8376,0,1.9519,3.56,3.8458,3.56,9.3006",
    fill: color,
    fillRule: "evenodd"
  })));
};
GreenhouseLogoTwo.defaultProps = {
  height: '24px',
  color: _constants.colors.evergreen
};
var _default = exports["default"] = GreenhouseLogoTwo;